import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core'
import Viewer from 'viewerjs';
import { SafeUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-image-viewer',
  standalone: true,
    imports: [],
  templateUrl: './image-viewer.component.html',
  styleUrl: './image-viewer.component.scss'
})
export class ImageViewerComponent implements AfterViewInit, OnChanges {
    @ViewChild('viewer') viewerContainer: ElementRef;
    @Input() imageSrc: SafeUrl = 'https://cdn-lots.cosentino.com/cosentino/slab/1026277895.png';
    @Input() zoom: {level: number} = {level: 1};

    constructor(private renderer: Renderer2, private changesRef: ChangeDetectorRef) {}

    viewer: any;

    ngOnChanges(changes: SimpleChanges) {
        if(changes && changes['zoom'] && !changes['zoom'].firstChange){
            this.viewer.zoom(this.zoom.level)
        }
        if(changes && changes['imageSrc'] && !changes['imageSrc'].firstChange){
            this.changesRef.detectChanges()
            this.viewer.update()
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.viewer = new Viewer(this.viewerContainer.nativeElement, {
                inline: true,
                backdrop: true,
                navbar: false,
                title: false,
                minZoomRatio: 0.25,
                maxZoomRatio: 6,
                toolbar: false,
                button: false,
                scalable: false,
                tooltip: false
            });
        }, 300)
    }

}

